import { LeadForm } from "@modules/lead/components";
import { useRef } from "react";
import { FAQSection } from "@modules/study/common/sections";
import { getAssets } from "@unisearch/helpers";
import Link from "next/link";
import { Fragment, useEffect, useState } from "react";
import { BsStar, BsStarFill, BsStarHalf } from "react-icons/bs";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { HiPhone } from "react-icons/hi";
import { MdMail } from "react-icons/md";
import "react-multi-carousel/lib/styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ReactSVG } from "react-svg";
import styles from "./consultants.module.scss";

const faqData = [
  {
    id: 1,
    faqQuestion: "1. Does UniSearch charge for counselling services?",
    faqAnswer:
      "<p>No, UniSearch doesn’t charge for study abroad counselling!</p><p>For applications to the UK, Australia, Canada, Ireland, and New Zealand, UniSearch does not collect any service charges from students. Any fees involved for these applications are payable directly to the university, immigration authorities, or other organisations who are a necessary part of the process. These payments may include application fees, tuition fee deposits, visa processing fee, etc.</p><p>For applications to the USA, UniSearch charges a small fee to cover the administrative costs of fulfilling applications.</p>",
  },
  {
    id: 2,
    faqQuestion: "2. Does UniSearch offer application fee waivers?",
    faqAnswer:
      "<p>As a top study abroad consultant in Chandigarh and India, UniSearch does offer our students application fee waivers for partner universities! Connect with us to learn more about the universities you can apply to through UniSearch without application fees.</p>",
  },
  {
    id: 3,
    faqQuestion: "3. Can UniSearch help me get a scholarship?",
    faqAnswer:
      "<p>UniSearch can help you narrow down multiple funding opportunities for your overseas education journey. These include scholarships and educational loans! Our overseas education consultants help you narrow down scholarships you are eligible for and submit strong applications to boost your chances of success. UniSearch also provides one-to-one guidance to explore education loan opportunities with local banks.</p>",
  },
  {
    id: 4,
    faqQuestion:
      "4. Can UniSearch help me with admission and visa application to study abroad?",
    faqAnswer:
      "<p>Absolutely - that’s what we’re here for! UniSearch’s study abroad counsellors work with you one-to-one from the research and planning stage throughout your university application. This process includes thorough guidance for your LOR and SOP, English language test training courses, as well as scholarship and education loan support! Beyond this, we also assist with your visa application and pre-departure arrangements so you can set off on your study abroad journey with confidence.</p>",
  },
  {
    id: 5,
    faqQuestion: "5. Does UniSearch offer accommodation services?",
    faqAnswer:
      "<p>As leading overseas education consultants in Chandigarh and India, UniSearch partners with accommodation providers in all our key study abroad destinations to help you find your home away from home.</p>",
  },
  {
    id: 6,
    faqQuestion:
      "6.  I can’t visit you physically, can I still get support from UniSearch?",
    faqAnswer:
      "<p>Definitely! UniSearch takes its promise to make the right study abroad solutions accessible to every student very seriously. This is why, along with our branch offices, you can also reach us remotely through <a class='color-orange fw600' href='https://us06web.zoom.us/j/94960983299?pwd=N093UkVZd0JoMXczbmdhdTl4cWJ6UT09' target='_blank' rel='nofollow' >virtual office.</a></p>",
  },
  {
    id: 7,
    faqQuestion: "7. Does UniSearch help with preparing the LOR and SOP?",
    faqAnswer:
      "<p>Our expert study abroad counsellors have helped thousands of students just like you put together applications for admission success. And yes, this includes working on letters of recommendation/referral (LOR) and statements of purpose (SOP) for your applications!</p>",
  },
];

const ConsultantsInchandigarh = ({ pageData }) => {
  const ref = useRef(null);
  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FiChevronRight
        className={`${className} ReviewSliderTextArrowNext`}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FiChevronLeft
        className={`${className} ReviewSliderTextArrowPrev`}
        onClick={onClick}
      />
    );
  }

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    asNavFor: ".slider-nav",
    arrows: true,
    centerMode: false,
    infinite: false,
    centerPadding: "20px 0px",
    slidesToShow: 1,
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: false,
    swipeToSlide: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Fragment>
      {/* section hero */}
      <section className={styles.section_hero}>
        <div className="container">
          <div className={styles.hero_wrapper}>
            <div className={styles.heading_wrapper}>
              <h1>
                Welcome to <br /> UniSearch{" "}
                <span className="color-orange">Chandigarh</span>
              </h1>

              <div className={styles.destination_heading}>
                Popular Destinations:
              </div>
              <div className={styles.destination_country_wrapper}>
                <ul>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/australia.svg"
                      )}
                    />
                    <span>Australia</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/canada.svg"
                      )}
                    />
                    <span>Canada</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/ireland.svg"
                      )}
                    />
                    <span>Ireland</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/new-zealand.svg"
                      )}
                    />
                    <span>New Zealand</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets("assets/images/consultant/icon/usa.svg")}
                    />
                    <span>United State</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets("assets/images/consultant/icon/uk.svg")}
                    />
                    <span>United Kingdom</span>
                  </li>
                </ul>
              </div>
              <button
                onClick={handleClick}
                className="btn btn-md btn-secondary"
                style={{ width: "max-content" }}
              >
                Book your slot
              </button>
            </div>
            <div className={styles.destination_img_wrapper}>
              <img
                src={getAssets(
                  "assets/images/consultant/welcome-to-uniSearch-chandigarh.png"
                )}
                alt="Welcome to UniSearch Bangalore"
              />
              <div className={styles.student_count_wrapper}>
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/students.svg")}
                />
                <div className={styles.student_description}>
                  <h4>100,000+ Students</h4>
                  <p>Service Provide</p>
                </div>
              </div>
              <div className={styles.student_comunity_wrapper}>
                <div>
                  <span className={styles.satisfied_student}>
                    Our Satisfied Student Community
                  </span>
                  <span className={styles.active_user}>
                    Over 100,000 active users
                  </span>
                  <img
                    src={getAssets("assets/images/consultant/comunity.png")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section description */}
      <section className={styles.section_description}>
        <div className="container">
          <h2 className={styles.desc_heading}>
            Study Abroad <br />{" "}
            <span className="color-orange"> Consultants in Chandigarh</span>
          </h2>
          <p>
            Are you hoping to study abroad but not sure where to begin?
            UniSearch - the best study abroad consultants in Chandigarh - are
            here to help. At UniSearch, our goal is simple - making the right
            study abroad solutions accessible to every student, every step of
            the way.
          </p>
          <p>
            UniSearch Chandigarh’s study abroad consultants bring over 20 years
            of experience to the table, with thousands of successful university
            and student visa applications under their belts. They understand how
            to profile-match you to your ideal programs and{" "}
            <Link legacyBehavior href="/explore-university">
              <a>universities</a>
            </Link>{" "}
            in six major destinations:{" "}
            <Link legacyBehavior href="/united-states/university">
              <a>the USA, </a>
            </Link>{" "}
            <Link legacyBehavior href="/united-states/university">
              <a>UK, </a>
            </Link>{" "}
            <Link legacyBehavior href="/australia/university">
              <a>Australia, </a>
            </Link>{" "}
            <Link legacyBehavior href="/canada/university">
              <a>Canada, </a>
            </Link>{" "}
            <Link legacyBehavior href="/ireland/university">
              <a>Ireland, </a>
            </Link>
            and{" "}
            <Link legacyBehavior href="/new-zealand/university">
              <a>New Zealand</a>
            </Link>
            . Be it in person at our Chandigarh branch or remotely through our
            virtual office, these overseas education specialists go above and
            beyond to make your study abroad dreams come true.
          </p>
          <p>
            We offer end-to-end support throughout the program and university
            research stage and full application process, including scholarship
            and funding applications and English language test training. Our
            study abroad counsellors take this support beyond your applications
            with visa counselling, health cover selection, accommodation search,
            and even student work opportunities at your destination country.
          </p>
        </div>
      </section>

      {/* section offer */}
      <section className={styles.section_unisearch_offer}>
        <div className="container">
          <div className={styles.offers_wrapper}>
            <h2>
              As top study abroad consultants in Chandigarh,<br></br>
              <span className="color-orange">UniSearch offers you</span>
            </h2>
          </div>
          <div className={styles.offer_card_wrapper}>
            <div className={`${styles.offer_card} ${styles.blue}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/program.svg")}
              />
              <div>University and Program Shortlisting</div>
            </div>
            <div className={`${styles.offer_card} ${styles.light_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/application.svg")}
              />
              <div>End-to-End Application Support</div>
            </div>
            <div className={`${styles.offer_card} ${styles.dark_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/language.svg")}
              />
              <div>English Language Test Training</div>
            </div>
            <div className={`${styles.offer_card} ${styles.gray}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/education.svg")}
              />
              <div>Scholarship and Education Loan Assistance</div>
            </div>

            <div className={`${styles.offer_card} ${styles.green}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/visa.svg")}
              />
              <div>Visa Counselling</div>
            </div>

            <div className={`${styles.offer_card} ${styles.dark_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/health.svg")}
              />
              <div>Overseas Health Education Cover</div>
            </div>

            <div className={`${styles.offer_card} ${styles.blue}`}>
              <ReactSVG
                src={getAssets(
                  "assets/images/consultant/icon/accomodation.svg"
                )}
              />
              <div>Accommodation and Housing Search</div>
            </div>

            <div className={`${styles.offer_card} ${styles.light_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/job.svg")}
              />
              <div>On-Shore Student Job Guidance</div>
            </div>
          </div>
        </div>
      </section>

      {/* section support */}
      <section className={styles.section_support}>
        <div className="container">
          <div className={styles.support_wrapepr}>
            <div className="from_texteditor_wrapper">
              <h2>
                UniSearch is There for You Through Every Step of Your{" "}
                <span className="color-orange">Study Abroad</span> Journey
              </h2>
              <ul className="">
                <li>One-to-one counselling at our physical branches</li>
                <li>Virtual offices open 12 hours a day</li>
                <li>Personalised study abroad solutions for each student</li>
                <li>Pre-, during, and post-application support</li>
              </ul>
            </div>
            <div className={styles.unisearch_support_wrapper}>
              <img
                src={getAssets(
                  "assets/images/consultant/unisearch-support.png"
                )}
                alt="Welcome to UniSearch Bangalore"
              />
              <div className={styles.unisearch_support}>
                <ReactSVG
                  src={getAssets(
                    "assets/images/consultant/icon/university.svg"
                  )}
                />
                <div className={styles.student_description}>
                  <h4>500+ University</h4>
                  <p>Find the right fit for you</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section Target English Language */}
      <section className={styles.section_support}>
        <div className="container">
          <div className={styles.support_wrapepr}>
            <div className={`${styles.english_test} relative`}>
              <img
                src={getAssets(
                  "assets/images/consultant/language-test-band.png"
                )}
                alt="Welcome to UniSearch Bangalore"
              />

              <div
                className={`${styles.student_count_wrapper}  ${styles.satisfied_student}`}
              >
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/graduate.svg")}
                />
                <div className={`${styles.student_description}`}>
                  <h4>3,950+</h4>
                  <p>Satisfied Student</p>
                </div>
              </div>
            </div>
            <div className="from_texteditor_wrapper">
              <h2>
                Get Your Desired English Language{" "}
                <span className="color-orange">Test Scores</span>
              </h2>
              <p>
                As leading overseas education consultants in Chandigarh,
                UniSearch supports you in accessing your target English language
                test scores too. With our best-in-class trainers and their
                impressive track records of ensuring score success, you’re in
                the hands of experts. We offer both online and offline courses
                for{" "}
                <Link legacyBehavior href="/elearning/ielts">
                  <a className="color-orange fw600"> IELTS</a>
                </Link>{" "}
                and{" "}
                <Link
                  legacyBehavior
                  href="/lead/the-complete-pte-academic-training-program"
                >
                  <a className="color-orange fw600">PTE Academic</a>
                </Link>{" "}
                with the flexibility to choose the plan you need. Hit your
                target scores for English proficiency exams with our
                student-focused courses and masterclasses for the IELTS and PTE
                Academic
              </p>

              <ul className="">
                <li>Expert trainers with insider tips and strategies</li>
                <li>Small class batches for personalised teaching</li>
                <li>Official study materials</li>
                <li>Practice sessions, evaluations, and mock tests</li>
                <li>Doubt-clearing sessions and extended course validity</li>
                <li>On- and offline training available</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* section location */}
      <section
        className={styles.section_location}
        style={{ position: "relative" }}
      >
        <div className={styles.address_wrapper}>
          <div className="container">
            <div className={styles.address_container}>
              <div></div>
              <div className={styles.empty_div}></div>
              <div
                className={`${styles.address_card_wrapper} ${styles.address_card_location} ${styles.location_card}`}
              >
                <div className={styles.address_card_location_heading}>
                  Location:
                </div>
                <ul>
                  <li>
                    <FaMapMarkerAlt style={{ color: "#1198FC" }} />
                    <div>
                      <div className={styles.location_title}>Address:</div>
                      <div>
                        Unisearch, 3rd Floor, SCO No 68-69, above PNB Metlife
                        Office, 17B, Chandigarh, 160017, India
                      </div>
                    </div>
                  </li>
                  <li>
                    <MdMail style={{ color: "#4AC8A6" }} />
                    <div>
                      <div className={styles.location_title}>Email:</div>
                      <a href="mailto:info.chandigarh@myunisearch.com">
                        info.chandigarh@myunisearch.co
                      </a>
                    </div>
                  </li>
                  <li>
                    <HiPhone style={{ color: "#5D5FEF" }} />
                    <div>
                      <div className={styles.location_title}>Phone:</div>
                      <a href="tel:017-24118996">017-24118996</a>
                    </div>
                  </li>
                </ul>
              </div>
              <div className={styles.address_card_wrapper}>
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/address.svg")}
                />
                <div className={styles.location_title_two}>Location Guide</div>
                <div>
                  Go to the Bank Square in Sector 17-B of Chandigarh. Find the
                  passage to reach PNB Metlife Office [SCO 78-79]. UniSearch
                  Chandigarh is located on the 3rd Floor of the same building.
                </div>
              </div>
              <div className={styles.address_card_wrapper}>
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/bus.svg")}
                />
                <div className={styles.location_title_two}>Location Guide</div>
                <div>
                  17-minute walk from Chandigarh Bus Station [Sector-17]
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.map_wrapper}>
          <iframe
            id="myIframe"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13716.913934425722!2d76.7868521!3d30.7400829!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x90adec4ae0625dca!2sUNISEARCH!5e0!3m2!1sen!2sbd!4v1663067195137!5m2!1sen!2sbd"
            width="800"
            height="600"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {/* section form */}
      <section id="book_your_slot" ref={ref}>
        <div className="container">
          <div className={styles.form_wrapper}>
            <LeadForm
              pageSlug="study-abroad-consultants-in-chandigarh"
              pageData={pageData}
            />
          </div>
        </div>
      </section>

      {/* section review */}
      <section className={styles.section_review}>
        <div className="container">
          <>
            <div
              className={`${styles.review_slider_person} ReviewSliderPerson`}
            >
              <Slider
                {...settingsThumbs}
                asNavFor={nav1}
                ref={(slider) => setSlider2(slider)}
              >
                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets("assets/images/consultant/Siddarth.jpg")}
                    alt="Siddarth"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets("assets/images/consultant/Koyel.jpg")}
                    alt="Koyel"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets(
                      "assets/images/consultant/Mannat Chawla.jpg"
                    )}
                    alt="Mannat Chawla"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets("assets/images/consultant/Palak Arora.jpg")}
                    alt="Palak Arora"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets("assets/images/consultant/Baidwan.jpg")}
                    alt="Baidwan"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets("assets/images/consultant/Rani.jpg")}
                    alt="Rani"
                  />
                </div>
              </Slider>
            </div>

            <div className={styles.total_review_wrapper}>
              <div className={styles.total_review_stars}>
                {/* <Rating
                  name="half-rating-read"
                  defaultValue={2.5}
                  precision={0.5}
                  readOnly
                /> */}
                <BsStarFill />
                <BsStarFill />
                <BsStarFill />
                <BsStarFill />
                <BsStarHalf />

                <div className={styles.rating}>4.5</div>
              </div>
              <div className={styles.total_review_text}>
                Based on 1600+ reviews
              </div>
            </div>

            {/* reveiw text */}
            <div className="ReviewSliderText">
              <Slider
                {...settingsMain}
                asNavFor={nav2}
                ref={(slider) => setSlider1(slider)}
              >
                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "The UniSearch team was a huge help in helping me figure out
                    my doubts and queries about studying abroad! They helped me
                    through my whole Canada visa process and even with finding
                    housing. Thanks all!"
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Siddarth</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarHalf />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "I had many questions about studying abroad and UniSearch
                    staff were very patient and helpful throughout the process.
                    They were available at all hours whenever I needed help or
                    answers and my application went very smoothly thanks to
                    their help. Very thankful for their support"
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Koyel</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "The staff is really coordinating and cooperative, and
                    helped me to understand my weak points and work efficiently
                    on those. Recommended to everyone who is aspiring to score
                    great in their IELTS exam."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Mannat Chawla</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStar />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "I just joined a few days ago. All the staff are very nice
                    and helped me a lot, due to which I am able to score well
                    (for my IELTS). Recommend everyone to join for better
                    scoring."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Palak Arora</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarHalf />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "Great work, UniSearch
                    <br />
                    A great institute for IELTS coaching, teachers are brilliant
                    and helped me a lot to overcome my fear of IELTS. They have
                    updated topics and a great environment for studying.
                    <br />
                    Secondly, the visa department is also one of the best as
                    they help you in choosing the best university for you and in
                    all your documentation and other processes. <br />
                    Lastly, a big Thanks to them for being there for me, helping
                    me score 7.5 overall and making my dream of studying in
                    Thompson Rivers University come true. "
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Baidwan</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "The staff are really supportive throughout the process,
                    from required exams to the visa. They were available
                    whenever you need them, for their guidance. They put all
                    there efforts for you to get into your desired University.
                    It was really beneficial and amazing experience."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Rani Chuhan</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStar />
                  </div>
                </div>
              </Slider>
            </div>
          </>
        </div>
      </section>

      {/* section faq */}
      <FAQSection
        isCollapsed={false}
        title="Frequently Asked Questions (FAQs)"
        faqData={faqData}
      />
    </Fragment>
  );
};

export default ConsultantsInchandigarh;
